export  var  globalState = {};
